export enum ENUM_DENIED_REASONS {
  RECEPTTION_RECORD = 'RECEPTTION_RECORD',
  TRAFIC_RECORD = 'TRAFIC_RECORD',
  MURDER_RECORD = 'MURDER_RECORD',
  UNDER_AGE = 'UNDER_AGE',
  OTHERS = 'OTHERS',
}

export const LABEL_DENIED_REASONS: Record<ENUM_DENIED_REASONS, string> = {
  [ENUM_DENIED_REASONS.RECEPTTION_RECORD]: 'Antecedentes de receptação',
  [ENUM_DENIED_REASONS.TRAFIC_RECORD]: 'Antecedentes de tráfico',
  [ENUM_DENIED_REASONS.MURDER_RECORD]: 'Antecedentes de homicídio',
  [ENUM_DENIED_REASONS.UNDER_AGE]: 'Menor de idade',
  [ENUM_DENIED_REASONS.OTHERS]: 'Outros',
};
